export default __webpack_public_path__ + "locales/sr-Latn-RS/MainBar.json?hash=9995357a37c6b89908d873ccd3dbf0f1";